import { Component, inject } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterOutlet } from '@angular/router';
import { NavigationComponent } from './layout/navigation/navigation.component';
import { UserStateService } from './core/services/user.state.service';

@Component({
  selector: 'dnv-root',
  templateUrl: './app.component.html',
  imports: [
    RouterOutlet,
    FormsModule,
    ReactiveFormsModule,
  ],
})
export class AppComponent {
  userStateService = inject(UserStateService);
}
